import React, { useEffect, useState } from "react";
import DrawerComponent from "../ui/Drawer";
import LabelText from "../ui/LabelText";
import CloseIcon from "@mui/icons-material/Close";
import { ForawrdBackwardButton } from "../styled-components/PageHeaderStyles";
import ToggleButton from "../ui/ToggleButton/ToggleButton";
import { DrawerContainer, SearchResults } from "../styled-components/Drawer.Styles";
import PrimaryButton from "../ui/PrimaryButton";
import StandardDropdown from "../ui/StandardDropdown/StandardDropdown";
import { IOption } from "../types/IOption";
import { ITeamMatchByMonths } from "../types/ITimeline";
import RadioButton from "../ui/CustomRadioButton";
import MonthMatches from "./MonthMatches";
import styled from "styled-components";
import MCLogo from "../assets/sidebarIcons/MF logo.png";

export interface SelectedData {
  matchId: number;
  seasonId: number;
  selectedOption?: string; // Optional if needed
  zoomLevelId: 1 | 2 | 3 | 4;
  overall?: boolean;
}

interface TimelineProps {
  isOpen: boolean;
  onClose: () => void;
  teamId: number;
  seasonData: IOption[];
  teamMatchByMonthsData: ITeamMatchByMonths[];
  onConfirm: (selectedData: SelectedData) => void;
  zoomLevelId: number;
  selectedSeasonId: number;
  isHideMatchOptions?: boolean;
  onSeasonChange?: (seasonId: number) => void;
}

const options = [
  { label: "First 3rd", value: "FirstThird" },
  { label: "Middle 3rd", value: "MiddleThird" },
  { label: "Last 3rd", value: "FinalThird" },
];

const timelineSelection = [
  { id: 4, key: "overall", value: "OVERALL" },
  { id: 3, key: "fullSeason", value: "FULL SEASON" },
  { id: 1, key: "matchLevel", value: "SINGLE MATCH" },
];

const TimelineDiv = styled.div`
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.scrollbarTrack};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollbarThumb};
  }
`;

const Timeline: React.FC<TimelineProps> = ({
  isOpen,
  onClose,
  teamId,
  seasonData,
  teamMatchByMonthsData,
  onConfirm,
  zoomLevelId,
  selectedSeasonId,
  isHideMatchOptions,
  onSeasonChange,
}) => {
  const [selectedTimeLine, setSelectedTimeLine] = useState<string>("");
  const [selectedMatch, setSelectedMatch] = useState<number>(-1);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [seasonId, setSeasonId] = useState<number>(selectedSeasonId || 0);

  useEffect(() => {
    const selectedItem = timelineSelection.find((item) => item.id === zoomLevelId);
    if (selectedItem) {
      setSelectedTimeLine(selectedItem.key);
    }
  }, [zoomLevelId]);

  const handleSearchResult = () => {
    if (selectedTimeLine === "matchLevel" && selectedMatch !== -1) {
      onClose();
      onConfirm({ matchId: selectedMatch, seasonId: selectedSeasonId, selectedOption, zoomLevelId: 1 });
    } else if (selectedTimeLine === "3rdofASeason" && seasonId !== 0 && selectedOption !== "") {
      const zoomLevel = selectedTimeLine === "3rdofASeason" ? 2 : selectedTimeLine === "matchLevel" ? 1 : 3;
      onClose();
      onConfirm({ matchId: -1, seasonId, selectedOption, zoomLevelId: 2 });
    } else if (selectedTimeLine === "fullSeason" && seasonId !== 0) {
      onClose();
      onConfirm({ matchId: -1, seasonId, selectedOption, zoomLevelId: 3 });
    } else if (selectedTimeLine === "overall") {
      onClose();
      onConfirm({ matchId: -1, seasonId, selectedOption, zoomLevelId: 4, overall: true });
    }
  };

  const handleMatchSelect = (matchId: number) => {
    setSelectedMatch(matchId);
  };
  const handleChange = (e: any) => {
    setSelectedOption(e.target.value);
  };
  const handleSeasonChange = (seasonId: string) => {
    const newSeasonId = Number(seasonId);
    setSeasonId(newSeasonId);
    onSeasonChange?.(newSeasonId);
  };

  const shouldDisplayConfirmButton = () => {
    if (selectedTimeLine === "matchLevel" && selectedMatch !== -1) return true;
    if (selectedTimeLine === "3rdofASeason" && seasonId !== 0 && selectedOption !== "") return true;
    if (selectedTimeLine === "fullSeason" && seasonId !== 0) return true;
    return selectedTimeLine === "overall";
  };

  return (
    <div className="timeline-drawer">
      <DrawerComponent open={isOpen} onClose={onClose} styleVariant={"timeline"} customClassName="sidebar-drawer-main timeline-drawer">
        <DrawerContainer className="main-drawer-container">
          <div className="drawer-header-content">
            <div className="drawer-header-top">
              <LabelText className="drawer-title">Timeline</LabelText>
              <div className="header-buttons">
                <ForawrdBackwardButton onClick={onClose}>
                  <CloseIcon className="cta-btn-icons" />
                </ForawrdBackwardButton>
              </div>
            </div>
            <div className="drawer-header-bottom">
              <ToggleButton
                labels={isHideMatchOptions ? timelineSelection.filter((timeline) => timeline.id !== 1) : timelineSelection}
                defaultLabelKey={selectedTimeLine}
                onChange={(selectedLabel) => setSelectedTimeLine(selectedLabel.key)}
              />
            </div>
          </div>
          <TimelineDiv className="timeline-content custom-scrollbar">
            {selectedTimeLine === "matchLevel" && (
              <>
                <LabelText className="header-text">Select a match</LabelText>
                {teamMatchByMonthsData.map((monthData, index) => (
                  <MonthMatches monthData={monthData} selectedMatch={selectedMatch} onMatchSelect={handleMatchSelect} />
                ))}
              </>
            )}
            {selectedTimeLine === "fullSeason" && (
              <>
                <LabelText className="header-text">Select a season</LabelText>
                <StandardDropdown
                  placeholder="Select a season"
                  options={seasonData}
                  onChange={handleSeasonChange}
                  isDisplaySearchInput={false}
                  defaultSelected={seasonData?.find((season) => season.value.toString() === selectedSeasonId.toString())?.label || ''}
                />
              </>
            )}
            {selectedTimeLine === "overall" && (
              <div className="overall-text-timeline">
                50+ matches worth of football data.
                <img src={MCLogo} alt="" />
              </div>
            )}
          </TimelineDiv>
          
        </DrawerContainer>
        {shouldDisplayConfirmButton() && (
            <SearchResults className="search-profile-result">
              <PrimaryButton onClick={handleSearchResult} iconType="confirm" label="Confirm" />
            </SearchResults>
          )}
      </DrawerComponent>
    </div>
  );
};

export default Timeline;
